export type { FooterNavProps } from './FooterNav';
export { FooterNav } from './FooterNav';
